<template>
    <div v-if="hasFilters" class="flex items-center gap-8 mt-12">
        <action-button
            icon="cancel"
            :key="index"
            v-for="(item, index) in items"
            @click="removeItem(item)"
        >
            {{ item.label }}
        </action-button>
        <action-button
            class="!bg-primary-20 hover:!bg-primary-60 !text-primary-80 hover:!text-white"
            icon="cancel"
            @click="removeAllFilters"
        >
            {{ $t('applications.filters.clear_filters') }}
        </action-button>
    </div>
</template>

<script>

import SvgIcon from '../../ui/SvgIcon.vue';
import ActionButton from "../../ui/ActionButton.vue";
export default {
    components: {
        ActionButton,
        'svg-icon': SvgIcon,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
        };
    },
    computed: {
        hasFilters() {
            return this.items.length > 0;
        }
    },
    methods: {
        removeItem(item) {
            this.$emit('remove', item);
        },
        removeAllFilters() {
            this.$emit('remove-all');
        }
    }
};
</script>
